import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { posthog, isPosthogConfigured } from '@/lib/posthog';

/**
 * Envoie un $pageview sur les pages publiques uniquement, si PostHog est initialisé
 * et que l’utilisateur a accepté les cookies (opt-in).
 */
export default function PostHogPageviewTracker() {
    const location = useLocation();

    useEffect(() => {
        if (!isPosthogConfigured()) return;
        if (location.pathname.startsWith('/admin')) return;
        if (localStorage.getItem('uta-cookie-consent') !== 'accepted') return;

        posthog.capture('$pageview', {
            $current_url: window.location.href,
        });
    }, [location.pathname, location.search]);

    return null;
}
